/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Alerts_TitleInputs */

const es_billing_alerts_title = /** @type {(inputs: Billing_Alerts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas de facturación`)
};

const en_billing_alerts_title = /** @type {(inputs: Billing_Alerts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing alerts`)
};

/**
* | output |
* | --- |
* | "Billing alerts" |
*
* @param {Billing_Alerts_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_alerts_title = /** @type {((inputs?: Billing_Alerts_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Alerts_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_alerts_title(inputs)
	return en_billing_alerts_title(inputs)
});
export { billing_alerts_title as "billing.alerts.title" }